import ImageWithBasePath from "./imageWithBasePath";

// Auth pages have no campus context (nobody's logged in yet), so we show BOTH
// group logos — The Eon Academy (campus 6) and the MPA group (all other
// campuses) — side by side with a divider, on mobile and desktop alike.
// Sizing is responsive: large on desktop, slightly smaller on phones. Both are
// height-capped so they stay balanced regardless of native aspect ratio.
const AuthLogos = () => (
  <>
    <style>{`
      .auth-logos {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
      }
      .auth-logos img {
        height: 120px;         /* mobile / default */
        width: auto;
        max-width: 46%;
        object-fit: contain;
      }
      .auth-logos .auth-logo-divider {
        width: 1px;
        height: 90px;
        background: rgba(0, 0, 0, 0.12);
        flex-shrink: 0;
      }
      @media (min-width: 992px) {
        .auth-logos { gap: 40px; }
        .auth-logos img { height: 200px; }          /* ~2x on large screens */
        .auth-logos .auth-logo-divider { height: 150px; }
      }
    `}</style>
    <div className="auth-logos mx-auto mb-5">
      <ImageWithBasePath src="assets/img/icons/logo.png" alt="The Eon Academy" />
      <span aria-hidden className="auth-logo-divider" />
      <ImageWithBasePath src="assets/img/icons/mpa-logo.png" alt="MPA" />
    </div>
  </>
);

export default AuthLogos;
